import { HomeOffIcon } from './HomeOffIcon';

/**
 * author: Michael Irigoyen
 * id D9B08A72-EDEB-459D-89C9-C12DFB088E98
 * name home-off
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-off.svg
 * tags
 * - Home Automation 
 */
export const HouseOffIcon = HomeOffIcon;
export default HouseOffIcon